import type { RouteRecordRaw } from 'vue-router'

import { useAuth } from '@/modules/Auth/useAuth'

const annotatorsRoute: RouteRecordRaw = {
  path: '/annotators',
  name: 'Annotators',
  component: () => import('@/modules/ReportsLegacy/RouteAnnotators.vue'),
  beforeEnter: (to, from, next) => {
    const { isAuthorized } = useAuth()

    // annotators are not allowed to see statistics
    if (!isAuthorized('view_full_datasets')) {
      return next(from.fullPath)
    }
    next()
  },
  meta: { requiresAuth: true },
}

export default annotatorsRoute
